import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardActions,
  CardBody,
  CardContent,
  CardTitle,
  Checkbox,
  Typography,
  SelectionControlLabel
} from '@one-thd/sui-atomic-components';
import { TableDataShape } from '../../shapes/TableData';

function TableRow(tableData, preference, sendUpdated) {

  const [preferences, setPreferences] = React.useState(false);

  useEffect(() => {
    setPreferences(preference);
  }, [preference]);

  return (title) => {
    const { subText } = tableData[title];

    const handleChange = (event) => {
      const checked = event.target.checked;
      sendUpdated(checked);
      setPreferences(checked);
    };

    const inputAttributes = { 'aria-label': `checkbox-${title}` };

    return (
      <Card disablePadding>
        <CardContent>
          <CardTitle
            header={(
              <Typography
                variant="h5"
                weight="base"
                height="snug"
                lineClamp="3"
              >
                {title}
              </Typography>
            )}
            key={title}
          />
          <CardBody>
            <Typography variant="body-base">{subText}</Typography>
          </CardBody>
          <CardActions>
            <SelectionControlLabel value="e-receipt-email" label="Email">
              <Checkbox
                orientation="horizontal"
                inputAttributes={inputAttributes}
                checked={preferences}
                onChange={handleChange}
              />
            </SelectionControlLabel>
          </CardActions>
        </CardContent>
      </Card>
    );
  };
}

function EReceiptCard({ tableData, preference, sendUpdated }) {
  const tableRow = TableRow(tableData, preference, sendUpdated);

  return (
    Object.keys(tableData).map(tableRow)
  );

}

EReceiptCard.propTypes = {
  tableData: TableDataShape.isRequired,
  sendUpdated: PropTypes.func.isRequired,
  preference: PropTypes.string.isRequired,
};

export default EReceiptCard;
